import Layout from '@/components/feature/Layout';
import JsonLd, { getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CategoryNav from './components/CategoryNav';
import TrendingSection from './components/TrendingSection';
import ReadingModeSection from './components/ReadingModeSection';
import LatestSection from './components/LatestSection';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  return (
    <>
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getWebSiteSchema()} />
      <JsonLd data={getWebPageSchema(
        '爱漫画网 - 下拉式漫画阅读 | 翻页漫画 | 无弹窗漫画 | 全屏观看',
        '爱漫画网提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看。沉浸式追漫体验让免费看漫画全集更流畅。',
        'https://aimanhua.com'
      )} />
      <Layout>
        <HeroSection />
        <StatsBar />
        <CategoryNav />
        <TrendingSection />
        <ReadingModeSection />
        <LatestSection />
        <ArticleSection />
      </Layout>
    </>
  );
}